<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M12.4999 1.66675H4.99995C4.55792 1.66675 4.134 1.84234 3.82144 2.1549C3.50888 2.46746 3.33328 2.89139 3.33328 3.33341V16.6667C3.33328 17.1088 3.50888 17.5327 3.82144 17.8453C4.134 18.1578 4.55792 18.3334 4.99995 18.3334H14.9999C15.442 18.3334 15.8659 18.1578 16.1785 17.8453C16.491 17.5327 16.6666 17.1088 16.6666 16.6667V5.83341L12.4999 1.66675Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6667 1.66675V5.00008C11.6667 5.44211 11.8423 5.86603 12.1549 6.17859C12.4674 6.49115 12.8914 6.66675 13.3334 6.66675H16.6667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.33338 7.5H6.66672"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.3334 10.8333H6.66672"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.3334 14.1667H6.66672"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconFile',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
